module.exports = __webpack_public_path__ + "img/sphc.56147709.png";